export const ABRIR_EXECUCAO_B2B_DATA = {
  id: '725b77e2-bd35-4d68-acca-c3c3d9b79750',
  status: 'in-progress',
  class: {
    code: 'AMB',
    system: 'http://terminology.hl7.org/CodeSystem/v3-ActCode',
    display: 'ambulatorial',
  },
  subject: {
    reference: '#pat-1',
  },
  location: [
    {
      location: {
        reference: '#loc-1',
      },
    },
  ],
  contained: [
    {
      id: 'pat-1',
      name: [
        {
          use: 'official',
          text: 'João da Silva',
        },
        {
          use: 'usual',
          text: 'João da Silva',
        },
      ],
      gender: 'male',
      birthDate: '1971-07-02',
      resourceType: 'Patient',
    },
    {
      id: 'pract-1',
      name: [
        {
          use: 'official',
          text: 'Maria dos Santos Teixeira',
        },
      ],
      gender: 'female',
      resourceType: 'Practitioner',
    },
    {
      id: 'practrole-1',
      specialty: {
        coding: [
          {
            code: '225125',
            system:
              'http://healthit.medflowapp.com/fhir/CodeSystem/tuss-tab-24',
            display: 'Clínica geral',
          },
        ],
      },
      practitioner: {
        reference: '#pract-1',
      },
      resourceType: 'PractitionerRole',
    },
    {
      id: 'org-1',
      name: 'SUS',
      resourceType: 'Organization',
    },
    {
      id: 'loc-1',
      name: 'Hospital São Jorge',
      resourceType: 'Location',
    },
  ],
  participant: [
    {
      individual: {
        reference: '#practrole-1',
      },
    },
  ],
  resourceType: 'Encounter',
  serviceProvider: {
    reference: '#org-1',
  },
};
